import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "./auth";

export const RequireAdmin = ({ children }) => {
  const token = getToken();
  if (!token) return <Navigate to="/admin" replace />;
  return children;
};

export const RedirectIfAuthed = ({ children }) => {
  const token = getToken();
  if (token) return <Navigate to="/admin/dashboard" replace />;
  return children;
};
